import { useState, useContext } from "react";
import {
  Box,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Typography,
  TableContainer,
  Stack,
} from "@mui/material";

//Srcs
import "../../../Style/pagestyle.scss";
import { AuthContext } from "../../../Context/AuthContext";
import { SelectParty } from "../../../Components/Include/DynamicSelect";
import { useNavigate } from "react-router-dom";
import { useGetCandidatePagination } from "../../../Hooks/useGetCandidatePagination";
import { ButtonCreate, SearchTextField } from "../../../Utils/Component";

import moment from "moment";
import EmptyData from "../../../Components/Include/EmptyData";
import LoadingPage from "../../../Utils/LoadingPage";
import CandidateForm from "../../../Components/Candidate/CandidateForm"; 
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import useWithDimension from "../../../Hooks/useWithDimension";
import CandidateAction from "../../../Components/Candidate/CandidateAction";
import CopyCandidateForm from "../../../Components/Candidate/CopyCandidateForm";

const getPartyFromLocal = () => {
  const data = JSON.parse(window.localStorage.getItem("partyId"));
  return data ? data : { id: "", title: "" };
};

const setPartyFromLocal = (value) => {
  window.localStorage.setItem("partyId", JSON.stringify(value));
};

export default function TabCandidate() {
  const { t } = useContext(AuthContext);
  const partyData = getPartyFromLocal();
  const [isActive, setIsActive] = useState(true);
  const [selectParty, setSelectParty] = useState(partyData);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openCopy, setOpenCopy] = useState(false);
  const handleOpenCopy = () => setOpenCopy(true);
  const handleCloseCopy = () => setOpenCopy(false);

  const navigate = useNavigate();
  const {
    refetch,
    loading,
    tableData,
    handleSearch,
  } = useGetCandidatePagination({ 
    isActive: isActive, 
    partyId: selectParty?.id || "",
  });
  const handleNavigate = (id) => {
    navigate(`/parties-and-candidates/member-details?id=${id}`);
  };
  // ======================= Resize width Screen ======================
  const { width } = useWithDimension();

  
  return (
    <div className="page-container">
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className={t("class-name-text-field-title")}>
              {t("search")}
            </Typography>
            <SearchTextField
              className={"text-field"}
              handleSearch={handleSearch}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_party")}
            </Typography>
            <SelectParty
              dialogTitle={partyData?.id ? null : "Create"}
              buttonAdd={false}
              className={"text-field"}
              value={selectParty}
              onChange={(val) => {
                setPartyFromLocal(val);
                setSelectParty(val);
              }}
            />
          </Grid>

          {/* <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_status")}
            </Typography>
            <FormControl className={"text-field"} fullWidth size="small">
              <Select
                value={isActive.toString()}
                onChange={(e) => setIsActive(e.target.value === "true")}
              > 
                <MenuItem value="true">Active</MenuItem>
                <MenuItem value="false">Inactive</MenuItem>
              </Select>
            </FormControl>
          </Grid> */}

          <Grid item xs={12} sm={12} md={4} lg={6} xl={7.2}>
            <Stack direction="row" justifyContent="flex-end" alignItems="flex-end" height="100%" spacing={1} >
              <Box>
                <ButtonCreate
                  handleOpen={handleOpenCopy}
                  classBtn={"btn-delete"}
                  classIcon={"icon-add"}
                  title={t("copy")}
                  icon={<ContentCopyIcon />}
                />
              </Box>
              <Box>
                <ButtonCreate
                  handleOpen={handleOpen}
                  classBtn={"btn-create"}
                  classIcon={"icon-add"}
                />
              </Box>
            </Stack>

            <CandidateForm
              open={open}
              handleClose={handleClose}
              setRefetch={refetch}
              dialogTitle="Create"
            />

            <CopyCandidateForm
              open={openCopy}
              handleClose={handleCloseCopy}
              setRefetch={refetch}
            />

          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="4%"
                >
                  {t("no")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="21%">
                  {t("thead_full_name")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="20%">
                  {t("thead_date_of_birth")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="15%">
                  {t("thead_gender")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="15%">
                  {t("thead_candidate")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="10%" align="center">
                  {t("thead_number_order")}
                </TableCell>
                <TableCell className={t("class-name-header-title-end")} width="10%"></TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell
                    colSpan={9}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 || tableData?.length === undefined ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={9} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell
                              className="body-cell-start"
                              onClick={() => handleNavigate(row?.candidateId?._id)}
                            >
                              {index + 1}
                            </TableCell>

                            <TableCell
                              className="body-cell"
                              onClick={() => handleNavigate(row?.candidateId?._id)}
                            >
                              {[
                                row?.candidateId?.lastNameKh,
                                row?.candidateId?.firstNameKh,
                              ]
                                .filter((e) => e)
                                .join(" ")}
                            </TableCell>

                            <TableCell
                              className="body-cell"
                              onClick={() => handleNavigate(row?.candidateId?._id)}
                            >
                              {row?.candidateId?.dateOfBirth &&
                                moment(row?.candidateId?.dateOfBirth).format(
                                  "DD-MM-YYYY"
                                )}
                            </TableCell>

                            <TableCell
                              className="body-cell"
                              onClick={() => handleNavigate(row?.candidateId?._id)}
                            >
                              {row?.candidateId?.gender === "Male"
                                ? t("thead_male")
                                : t("thead_female")}
                            </TableCell>

                            <TableCell
                              className="body-cell"
                              sx={{
                                color:
                                  row?.candidateType === "full_rights"
                                    ? "green"
                                    : "red",
                              }}
                              onClick={() => handleNavigate(row?.candidateId?._id)}
                            >
                              {t(`thead_${row?.candidateType}`)}
                            </TableCell>

                            <TableCell align="center"
                              className="body-cell"
                              onClick={() => handleNavigate(row?.candidateId?._id)}
                            >

                              <Typography sx={{ fontWeight: "bold", color: "#223D97 !important", fontSize: 17, border: "1px solid #223D97", minHeight: 27.5 }}>
                                {row?.numberOrder}
                              </Typography>

                            </TableCell>

                            <TableCell className="body-cell-end" align="right">
                              <CandidateAction
                                editData={row}
                                setRefetch={refetch}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
